import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowRight, Phone } from 'lucide-react';
import { Button } from '../ui/button';
import { Reveal, RevealText } from '../motion/Reveal';
import { useMotionMode } from '../../contexts/MotionContext';

export const HomeCta = () => {
  const ref = useRef(null);
  const { cinematic, reduced } = useMotionMode();
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
  const bgX = useTransform(scrollYProgress, [0, 1], reduced ? ['0%', '0%'] : cinematic ? ['20%', '-30%'] : ['5%', '-10%']);

  return (
    <section ref={ref} className="relative py-28 lg:py-36 bg-black text-white overflow-hidden" data-testid="home-cta">
      <motion.p
        aria-hidden
        className="absolute inset-x-0 top-1/2 -translate-y-1/2 whitespace-nowrap text-[22vw] font-bold leading-none text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.08)] select-none pointer-events-none"
        style={{ x: bgX }}
      >
        OBSIDIAN
      </motion.p>
      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight"><RevealText text="Ready to Experience Luxury?" /></h2>
        <Reveal delay={0.15} className="text-lg md:text-xl text-gray-300 mb-12">
          Book your chauffeur service today and discover the Obsidian difference.
        </Reveal>
        <Reveal delay={0.3} className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/booking">
            <Button size="lg" className="bg-white text-black hover:bg-gray-200 text-lg px-8 py-6 h-auto rounded-none group" data-testid="home-cta-quote-btn">
              Get a Quote <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
          <a href="tel:03333357733">
            <Button size="lg" variant="outline" className="border border-white/60 bg-transparent text-white hover:bg-white hover:text-black text-lg px-8 py-6 h-auto rounded-none" data-testid="home-cta-phone-btn">
              <Phone className="mr-2 h-5 w-5" /> 0333 335 7733
            </Button>
          </a>
        </Reveal>
      </div>
    </section>
  );
};
